import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const ExcluirCadastroBtn = ({ endpoint, nome, onExcluido, testid }) => {
  const [loading, setLoading] = useState(false);

  const excluir = async () => {
    setLoading(true);
    try {
      const r = await api.delete(endpoint);
      toast.success(`"${r.data.excluido || nome}" excluído definitivamente. Todos os acessos vinculados foram removidos.`);
      if (onExcluido) onExcluido();
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setLoading(false); }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button className="text-xs font-semibold text-[#E60000] hover:underline" data-testid={testid}>
          Excluir
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Excluir "{nome}"?</AlertDialogTitle>
          <AlertDialogDescription>
            Tem certeza que deseja excluir? Esta ação é permanente e removerá todos os acessos vinculados.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="excluir-cancelar">Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={excluir} disabled={loading}
            className="bg-[#E60000] hover:bg-[#B91C1C] text-white" data-testid="excluir-confirmar">
            {loading ? "Excluindo…" : "Sim, excluir definitivamente"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
